import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/categories';

const steps = [
  {
    icon: 'ri-file-list-3-line',
    title: '归类你的问题',
    desc: '先判断属于消费纠纷、城市公共服务还是行业普遍现象，方向对了才有人接。',
  },
  {
    icon: 'ri-stack-line',
    title: '整理材料与时间线',
    desc: '把关键节点按时间排好，保留可核验的编号与完整上下文，可信度立刻提升。',
  },
  {
    icon: 'ri-share-forward-line',
    title: '匹配两到三个渠道',
    desc: '垂直渠道拿专业反馈，综合渠道扩大传播，避免同一条文案到处群发。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '投递并做好自保',
    desc: '遮盖头像、手机号等敏感信息，记录投递时间，一周左右礼貌询问进度。',
  },
];

export default function OverviewSections() {
  return (
    <>
      <section id="categories" className="border-b border-background-200 bg-background-50">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <SectionHeading
            eyebrow="按主题找入口"
            title="八大类别，快速定位你要去的地方"
            description="不同性质的问题适合不同的渠道。先选准类别，再挑具体入口，能省掉大量试错时间。"
            actionLabel="查看全部平台"
            actionTo="/directory"
          />

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`/directory?category=${category.id}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/40 cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
                    <i className={`${category.icon} text-xl`}></i>
                  </span>
                  <span className="font-heading text-sm text-foreground-400">{category.count} 个</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{category.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{category.description}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs text-primary-600">
                  进入分类<i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <SectionHeading
            eyebrow="四步走完流程"
            title="第一次找渠道，照着这四步来就行"
            description="从整理材料到安全投递，我们把新手最容易踩坑的环节拆成了四个动作。"
          />
          <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, index) => (
              <li key={step.title} className="relative rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="font-heading text-3xl font-bold text-background-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="mt-3 flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${step.icon} text-lg`}></i>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </>
  );
}